import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-11', 'IconNumber11', [["path",{"d":"M8 20v-16l-5 5","key":"svg-0"}],["path",{"d":"M18 20v-16l-5 5","key":"svg-1"}]]);